import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Icon, Icons} from '@pb/kit-component-icon';

import {downloadButton} from './download-button.module.styl';

type Props = {
    disabled: boolean,
    handler?: () => void,
};

export const DownloadButton: React.FC<Props> = ({disabled, handler}) => {
    return (
        <FlatButton
            startIcon={<Icon type={Icons.DOWNLOAD}/>}
            disabled={disabled}
            className={downloadButton}
            onClick={handler}>
            <b>Download</b>
        </FlatButton>
    );
};
